import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategoryQuickLinks() {
  const bgColors = [
    'from-primary-400/20 to-primary-500/10',
    'from-accent-400/20 to-accent-500/10',
    'from-secondary-400/20 to-secondary-500/10',
    'from-primary-300/20 to-accent-400/10',
  ];

  const iconColors = [
    'text-primary-500 bg-primary-100',
    'text-accent-500 bg-accent-100',
    'text-secondary-500 bg-secondary-100',
    'text-primary-600 bg-primary-100',
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">
            按分类浏览
          </h2>
          <p className="text-sm text-foreground-500">找到你最喜欢的番剧类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-5">
          {categories.filter(c => c.id !== 'all').map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category?type=${cat.id}`}
              className={`group relative rounded-xl bg-gradient-to-br ${bgColors[index % bgColors.length]} p-5 md:p-7 text-center hover:scale-[1.02] transition-all duration-300`}
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 md:mb-4 flex items-center justify-center rounded-xl ${iconColors[index % iconColors.length]}`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">
                海量{cat.name}资源
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}